import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../components/auth/AuthProvider';

const SessionContext = createContext({
  sessionId: null,
  setSessionId: () => {},
  userId: null,
});

export const SessionProvider = ({ children }) => {
  const { user } = useAuth();
  const [sessionId, setSessionId] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    setUserId(user?.sub || null);
  }, [user]);

  return (
    <SessionContext.Provider value={{ sessionId, setSessionId, userId }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
